/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { camelCaseToRegularForm, capitalizeFirstLetter } from 'serenova-js-utils/strings';

import styled from 'styled-components';
import { SearchIconSVG,FilterSelect } from 'cx-ui-components';

const Input = styled.input`
  width: 100%;
`;
const SearchIcon = styled(SearchIconSVG)`
  position: relative;
  left: -17px;
  opacity: 0.4;
`;

export function alpsStatus(string, customString) {
  const normalizedString = customString ? camelCaseToRegularForm(customString) : camelCaseToRegularForm(string);
  const column = {
    id: string,
    Header: <span title={normalizedString}>Status</span>,
    accessor: string,
    Cell: ({ row }) => {
      let value = row[string] == true ? "Enabled" : "Disabled";
      return <span title={value}>{value}</span>;
    },
    Filter: ({ filter, onChange }) => (
        <FilterSelect
        tableType="modal"
        onChange={(event) => onChange(event.target.value)}
        value={filter ? filter.value : 'all'}
        options={['all', 'Enabled', 'Disabled']}
      />
    ),
    filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true;
        }
        if (filter.value === 'Enabled') {
          return row[filter.id] === true;
        }
        if (filter.value === 'Disabled') {
          return row[filter.id] === false;
        }
      },
  };
  column.Cell.propTypes = {
    row: PropTypes.any
  };
  column.Filter.propTypes = {
    filter: PropTypes.func,
    onChange: PropTypes.func
  };

  return column;
}
